export default {
  path: 'register',
  component: () => import(/* webpackChunkName: "register" */ '@/pages/passport/Register'),
}

